import React from 'react'
import { PlayButton } from './assets/PlayButton'
import { SevenPlusLogo } from './assets/SevenPlusLogo'
import { StyledButton } from './ScoreBoard.styled'

interface ScoreBoardMoreButtonProps {
    type: 'cricket' | 'afl'
}

export const ScoreBoardMoreButton = ({ type }: ScoreBoardMoreButtonProps) => {
    switch (type) {
        case 'cricket':
            return (
                <StyledButton to="https://7plus.com.au/7-cricket?utm_source=7NEWS&utm_medium=match-centre&utm_campaign=cricket">
                    <PlayButton />
                    More Cricket on <SevenPlusLogo />
                </StyledButton>
            )
        case 'afl':
            return (
                <StyledButton to="https://7plus.com.au/afl?utm_source=7NEWS&utm_medium=afl-match-centre-button&utm_campaign=afl">
                    <PlayButton /> More AFL on <SevenPlusLogo />
                </StyledButton>
            )
        default:
            return null
    }
}
